import React, { useEffect } from "react";
import CustomButton from "../components/CustomButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AgentConfig } from "./AgentsStore";
import { FormField, ResponsiveContext, TextInput } from "grommet";
import { EventConfig } from "../events/EventsStore";
import { toPairs } from "lodash";
import { RenderLEDBarAction } from "./LEDBarAction";

const desktop = <FontAwesomeIcon icon={["fad", "desktop"]}></FontAwesomeIcon>;
const camera = <FontAwesomeIcon icon={["fad", "camera"]}></FontAwesomeIcon>;
const image = <FontAwesomeIcon icon={["fad", "image"]}></FontAwesomeIcon>;
const hourglass = <FontAwesomeIcon icon={["fad", "hourglass-start"]}></FontAwesomeIcon>;

const AgentControls = ({ onChange, config, eventConfig }: { onChange: Function; config?: AgentConfig; eventConfig?: EventConfig }) => {
    const [rtspFeed, setRtspFeed] = React.useState(config?.rtspFeed);

    useEffect(() => {
        setRtspFeed(config?.rtspFeed);
    }, [config?.rtspFeed]);

    const size = React.useContext(ResponsiveContext);

    return (
        <>
            {config && size != "small" && (
                <FormField label="RTSP Url">
                    <TextInput value={rtspFeed} onChange={(e) => setRtspFeed(e.target.value)} onBlur={() => onChange({ ...config, rtspFeed })}></TextInput>
                </FormField>
            )}
            <CustomButton size="small" primary={config?.source == 0} icon={desktop} label="Desktop" onClick={() => onChange({ ...config, source: 0 })}></CustomButton>
            {/* <CustomButton primary={config?.source == 1} icon={camera} label="Camera" onClick={() => onChange({ ...config, source: 1 })}></CustomButton> */}
            <CustomButton size="small" primary={config?.source == 2} icon={image} label="Static" onClick={() => onChange({ ...config, source: 2 })}></CustomButton>
            <CustomButton size="small" primary={config?.source == 3} icon={hourglass} label="Stand By" onClick={() => onChange({ ...config, source: 3 })}></CustomButton>
            {eventConfig &&
                toPairs(eventConfig.ledBarActions).map(([action, ledConfig]) => (
                    <div onClick={() => onChange({ ...config }, ledConfig)} key={action}>
                        <RenderLEDBarAction style={{ width: "100px" }} config={ledConfig} name={action}></RenderLEDBarAction>
                    </div>
                ))}
        </>
    );
};

export default AgentControls;
